import PropTypes from 'prop-types';
import PaymentButton from './PaymentButton';
import './Paywall.css';

const Paywall = ({
  title,
  description,
  onSubscribe,
  onClose,
  ctaLabel,
  paymentButtonId,
  paymentLink,
  showUnlockHint,
  priceLabel,
  features,
}) => {
  const handleSubscribe = () => {
    if (onSubscribe) {
      onSubscribe();
      return;
    }
    if (paymentLink) {
      window.location.href = paymentLink;
    }
  };

  return (
    <div className="paywall-card">
      {onClose && (
        <button className="paywall-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      )}
      <div className="paywall-icon">🔒</div>
      <div className="paywall-price">{priceLabel || '₹5'}</div>
      <h2>{title}</h2>
      <p>{description}</p>

      {features?.length > 0 && (
        <ul className="paywall-features">
          {features.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}

      {paymentButtonId ? (
        <PaymentButton paymentButtonId={paymentButtonId} />
      ) : (
        <button className="paywall-btn pulse" onClick={handleSubscribe}>
          {ctaLabel || `Subscribe for ${priceLabel || '₹5'}`}
        </button>
      )}
      <p className="paywall-note">You will be redirected to our secure Razorpay checkout.</p>
      {showUnlockHint && (
        <p className="paywall-hint">Already paid? Click unlock below.</p>
      )}
    </div>
  );
};

Paywall.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onSubscribe: PropTypes.func,
  onClose: PropTypes.func,
  ctaLabel: PropTypes.string,
  paymentButtonId: PropTypes.string,
  paymentLink: PropTypes.string,
  showUnlockHint: PropTypes.bool,
  priceLabel: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
};

Paywall.defaultProps = {
  ctaLabel: undefined,
  onSubscribe: undefined,
  onClose: undefined,
  paymentButtonId: undefined,
  paymentLink: undefined,
  showUnlockHint: false,
  priceLabel: '₹5',
  features: [],
};

export default Paywall;
